import { useMemo } from 'react';
import type { MKEERAApiResponseItem } from '../dashboard.types';
import { parseAmount } from '../utils/dataProcessing';

export function useUtilityPayments(data: MKEERAApiResponseItem[]): number {
  return useMemo(() => {
    // Safety check: ensure data is an array
    if (!Array.isArray(data) || data.length === 0) {
      return 0;
    }

    return data.reduce((sum, item) => {
      const payeeType = item.applicationData.payeeType?.toLowerCase() || '';
      // Check for various utility-related payee types
      if (
        payeeType.includes('utility') ||
        payeeType.includes('electric') ||
        payeeType.includes('gas') ||
        payeeType.includes('water') ||
        payeeType.includes('sewer') ||
        payeeType.includes('trash') ||
        payeeType.includes('waste') ||
        payeeType.includes('energy') ||
        payeeType.includes('power')
      ) {
        return sum + parseAmount(item.applicationData.amountOfPayment);
      }
      return sum;
    }, 0);
  }, [data]);
}
